import { Banknote, CircleDollarSign, ShieldAlert, Undo2, CircleX } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { IStatItem } from "./types";
import { SummaryCard } from "./SummaryCard";
import { formatSummaryNumber, summaryNumber } from "./summaryData";

export type KpiKind = "turnover" | "declines" | "refunds" | "chargebacks";
const icons = { turnover: Banknote, declines: CircleX, refunds: Undo2, chargebacks: ShieldAlert };

export const KpiCard = ({ item, kind }: { item: IStatItem; kind?: KpiKind }) => {
	const { i18n } = useTranslation();
	const value = summaryNumber(item.data);
	const Icon = kind ? icons[kind] : CircleDollarSign;
	const title = item.prefix && item.title.endsWith(`, ${item.prefix}`) ? item.title.slice(0, -item.prefix.length - 2) : item.title;
	const exact = `${item.prefix ? `${item.prefix} ` : ""}${formatSummaryNumber(value, i18n.language)}`;
	return <SummaryCard title={title} icon={<Icon size={20} aria-hidden="true" />} prefix={item.prefix}>
		<div className="amount">
			<div className="metric" title={exact} aria-label={exact}>{formatSummaryNumber(value, i18n.language, !!item.prefix)}</div>
			{item.subtitle && <p className="caption">{item.subtitle}</p>}
		</div>
	</SummaryCard>;
};
